import rfpIconTemplate from './rfpIcon.html';

const rfpIcon = {
    bindings: {
        enabled: '=',
    },
    template: rfpIconTemplate,
};

export default rfpIcon;



/** WEBPACK FOOTER **
 ** ./src/app/directives/rfpIcon/rfpIcon.js
 **/